exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1kwbGxKcpGcXaS-QPMqPXU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;overflow:hidden;height:100%}._1kwbGxKcpGcXaS-QPMqPXU ._3LedXO9Lzk1YgPVoliYhj4,._1kwbGxKcpGcXaS-QPMqPXU ._3HLOqbQ3uPSrLrtwu-g-je{width:50%;overflow:auto}", ""]);
// Exports
exports.locals = {
	"twoColumnInspector": "_1kwbGxKcpGcXaS-QPMqPXU",
	"itemDetails": "_3LedXO9Lzk1YgPVoliYhj4",
	"itemList": "_3HLOqbQ3uPSrLrtwu-g-je"
};